import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Download, MessageCircle, Calendar, AlertCircle } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: FileText,
    text: 'PDF principal (45–70 páginas)'
  }, {
    icon: Download,
    text: 'Plantilla del Mapa de Carga Mental del Bebé'
  }, {
    icon: Download,
    text: 'Plantillas de Tarjetas de Propiedad listas para imprimir'
  }, {
    icon: MessageCircle,
    text: 'Guiones de 2 minutos (para hablar sin pelea)'
  }, {
    icon: Calendar,
    text: 'Plan día a día por 14 días (micro-pasos, sin sobrecarga)'
  }, {
    icon: AlertCircle,
    text: "Sección 'cuando falla' (noches malas, visitas, crisis)"
  }];
  return <section className="w-full px-6 py-16 bg-[#F0EBE0]" data-id="element-37">
      <div className="max-w-reading mx-auto" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-39">
          <h2 className="text-3xl md:text-4xl text-brown mb-10 text-center" data-id="element-40">
            Lo que incluye{' '}
            <span className="italic text-brown/60" data-id="element-41">(y por qué funciona)</span>
          </h2>

          <div className="grid gap-4" data-id="element-42">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm border border-stone-100/50" data-id="element-43">
                <div className="w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 text-sage-DEFAULT" data-id="element-44">
                  <item.icon size={20} className="text-[#7A8A7C]" data-id="element-45" />
                </div>
                <span className="text-brown font-medium" data-id="element-46">{item.text}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}